const ROOT = "/permission-management";

const permissionManagementPaths = {
  root: ROOT,
  addPermission: `${ROOT}/add-permission`,
};

export default permissionManagementPaths;
